module.exports = __webpack_public_path__ + "static/img/pMRI4.45eec64d.png";